<template>
  <v-container id="section-tips">
    <v-layout justify-center align-center column>
      <v-flex text-center>
        <h2 class="primary--text mt-2 mb-4">
          <span>{{ articlesTips.header }}</span>
        </h2>
      </v-flex>

      <v-container>
        <v-layout
          class="section_inner"
          text-center
          align-center
          wrap
          justify-space-between
        >
          <v-flex
            v-for="(tip, index) in articles"
            :key="index"
            class="section-tips-item"
            row
            grow
            d-flex
            d-center
            lg3
            md3
            xs6
          >
            <Tip :item="tip" :img="tip.imageSrc" />
          </v-flex>
        </v-layout>
      </v-container>

      <v-layout class="text-center" justify-center>
        <DrBtn
          type-btn="orange_btn_large"
          :go-to-url="articlesTips.btn.link"
          target-url="_self"
        >
          {{ articlesTips.btn.text }}
        </DrBtn>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import Tip from '@/components/HomePageComponents/Article_Tip/Tip.vue';

export default {
  components: {
    Tip,
  },
  data() {
    return {
      articlesTips: t('titles.articlesTips')
    };
  },
  computed: {
    ...mapState({
      articles: (state) => state.homeDrushim.data.articles,
    }),
  },
};
</script>

<style lang="scss" scoped>
#section-tips .section-tips-item .theme--dark.v-card {
  background: none;
}
#section-tips .section-tips-item .v-card {
  border-radius: 10px;
  box-shadow: none;
}
.section-tips-item:hover {
  box-shadow: rgb(0 0 0 / 15%) 0 0 2px 2px;
}
</style>
